<template>
  <app-panel
    title="Employment"
    class="container"
    v-on:next="next"
    v-on:prev="prev"
    v-bind:showBack="true"
    v-bind:showNext="true"
  >
    <div class="row">
      <!-- Employer -->
      <b-form-group
        class="col-lg-4 col-md-6"
        id="input-group-first"
        label="Employer:"
        label-for="input-empl"
      >
        <b-form-input
          id="input-first"
          v-model="form.employer"
          type="text"
          required
          placeholder="Enter Employer"
        ></b-form-input>
      </b-form-group>
      <!-- Empl Years -->
      <b-form-group
        class="col-lg-4 col-md-6"
        id="input-group-last"
        label="Years with Employer:"
        label-for="input-years"
      >
        <b-input-group>
          <b-form-input
            id="input-last"
            v-model="form.emplYears"
            required
            type="number"
            placeholder="Enter Years With Employer"
            @keypress="isNumber($event)"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
      <!-- Phone -->
      <b-form-group
        class="col-lg-4 col-md-6"
        id="input-group-income"
        label="Monthly Income:"
        label-for="input-monthly-income"
        description="NOTICE: Alimony, child support or separate maintenance need not be included or revealed if you do not wish to rely on it to obtain credit."
      >
        <b-input-group>
          <b-form-input
            id="input-phone"
            v-model="form.monthlyIncome"
            required
            type="number"
            placeholder="Enter Monthly Income"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
    </div>
    <b-alert show variant="danger" v-for="error in errors" v-bind:key="error">{{error}}</b-alert>
  </app-panel>
</template>


<script>
import Datepicker from "vuejs-datepicker";
import appPanel from "./appPanel.vue";
export default {
  components: {
    Datepicker,
    appPanel
  },
  data() {
    return {
      form: {
        employer: "",
        emplYears: "",
        monthlyIncome: ""
      },
      errors: []
    };
  },
  methods: {
    validate() {
      this.errors = [];
      if (!this.form.employer.length) this.errors.push("Employer is Required");
      if (!this.form.emplYears.length)
        this.errors.push("Employer years is Required");
      if (!this.form.monthlyIncome.length)
        this.errors.push("Monthly Income is Required");
      if (!this.errors.length) return true;
    },
    next() {
      if (this.validate())
        this.$emit("next", {
          emplName: this.form.employer,
          emplYears: this.form.emplYears,
          monthlyIncome: this.form.monthlyIncome
        });
    },
    prev() {
      this.$emit("prev");
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode === 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>
<style>
.alert {
  margin-top: 5px;
}
.selectable-input {
  background-color: white !important;
}
.input-group-sep {
  margin-right: -1px;
  margin-left: -1px;
}
.input-group-sep > .input-group-text {
  border-radius: 0;
}
</style>
